var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_76_1",
    "data-name": "Component 76 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.501,
    height: 35.05,
    viewBox: "0 0 29.501 35.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17621",
    "data-name": "Path 17621",
    d: "M174.906,187.411a13.436,13.436,0,1,1,13.436-13.436A13.4,13.4,0,0,1,174.906,187.411Zm0-23.951a10.515,10.515,0,1,0,10.515,10.515A10.471,10.471,0,0,0,174.906,163.461Z",
    transform: "translate(-161.47 -152.361)",
    fill: "#b2b2c9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17622",
    "data-name": "Path 17622",
    d: "M315.993,115.278a1.38,1.38,0,0,1-1.461-1.461v-4.089a1.461,1.461,0,1,1,2.921,0v4.089A1.571,1.571,0,0,1,315.993,115.278Z",
    transform: "translate(-302.557 -104.179)",
    fill: "#b2b2c9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17623",
    "data-name": "Path 17623",
    d: "M253.01,64.034a1.38,1.38,0,0,1-1.461-1.461V60.383c0-.73-1.022-1.461-2.191-1.461h-4.381c-1.168,0-2.191.73-2.191,1.461v2.045a1.461,1.461,0,1,1-2.921,0V60.383c0-2.483,2.337-4.381,5.111-4.381h4.381c2.775,0,5.111,2.045,5.111,4.381v2.045a1.6,1.6,0,0,1-1.46,1.607Z",
    transform: "translate(-233.732 -56.002)",
    fill: "#b2b2c9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17624",
    "data-name": "Path 17624",
    d: "M315.993,284.648a1.38,1.38,0,0,1-1.461-1.461V277.2a1.325,1.325,0,0,1,.438-1.022l3.213-3.213a1.446,1.446,0,0,1,2.045,2.045l-2.775,2.775v5.4a1.463,1.463,0,0,1-1.461,1.461Z",
    transform: "translate(-302.557 -255.586)",
    fill: "#b2b2c9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17626",
    "data-name": "Path 17626",
    d: "M469.975,166.227a1.325,1.325,0,0,1-1.022-.438l-2.775-2.775a1.446,1.446,0,0,1,2.045-2.045L471,163.745a1.412,1.412,0,0,1,0,2.045,1.137,1.137,0,0,1-1.022.438Z",
    transform: "translate(-441.935 -152.354)",
    fill: "#b2b2c9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.7487afd61b0a3ee06530397e652732fa.svg";
export { ForwardRef as ReactComponent };